// extracted by mini-css-extract-plugin
module.exports = {"box":"box_box__If7Z0","row":"box_row__boHti","column":"box_column__96zOI","noPadding":"box_noPadding__0DTzq","modal":"box_modal__T1YUK"};